import Tabs from "@/components/Tabs";
import { useFlags } from "@/hooks/useFeatureFlags";
import { Path, useNavigate } from "@/router";
import { useLocation, useParams } from "react-router-dom";
import { SECTION_PEOPLE_CHANGE_REQUESTS_PATH, SECTION_PEOPLE_TABLE_PATH } from "../_utils";

type TabOption = {
  label: string;
  to: Path;
  active: boolean;
  testId: string;
};

export function SectionPeopleTabs() {
  const { sectionId } = useParams();
  const { pathname } = useLocation();
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();
  const flags = useFlags();
  const showRosterActivity = flags["backoffice-section-roster-activity"] === true;

  if (!sectionId || flags["backoffice-section-people"] !== true) {
    return null;
  }

  const peopleBase = `/sections/${sectionId}/people`;
  const peopleTableUrl = `${peopleBase}/section-people`;
  const nestedChangeRequestsUrl = `${peopleBase}/change-requests`;
  const legacyChangeRequestsUrl = `/sections/${sectionId}/change-requests`;

  const tabItems = (
    [
      {
        label: "People in Section",
        to: SECTION_PEOPLE_TABLE_PATH as Path,
        active: currentUrl === peopleTableUrl || currentUrl === peopleBase,
        testId: "tab-section-people"
      },
      {
        label: "Change Requests",
        to: SECTION_PEOPLE_CHANGE_REQUESTS_PATH as Path,
        active: currentUrl.startsWith(nestedChangeRequestsUrl) || currentUrl.startsWith(legacyChangeRequestsUrl),
        testId: "tab-section-change-requests"
      },
      showRosterActivity && {
        label: "Roster Activity",
        to: "/sections/:sectionId/roster-activity" as Path,
        active: currentUrl === `/sections/${sectionId}/roster-activity`,
        testId: "tab-section-roster-activity"
      },
      {
        label: "Audit Log",
        to: "/sections/:sectionId/audit-log" as Path,
        active: currentUrl === `/sections/${sectionId}/audit-log`,
        testId: "tab-section-audit-log"
      }
    ] as Array<TabOption | false>
  ).filter((tab): tab is TabOption => !!tab);

  return (
    <div data-testid="section-people-tabs">
      <Tabs
        tabItems={tabItems.map(({ label, to, active, testId }) => ({
          label,
          active,
          testId,
          onClick: () => navigate(to, { params: { sectionId } })
        }))}
      />
    </div>
  );
}

export default SectionPeopleTabs;
